import React, { } from "react"
import { Box, Button,   Icon, Image,  Link,  Input, Flex, InputGroup, InputLeftElement, Spacer,   } from "@chakra-ui/react"
import { NavLink, useNavigate } from "react-router-dom"

import { SearchIcon, }
    from "@chakra-ui/icons"


import { BiCartAlt } from "react-icons/bi";
import { AiOutlineUser } from "react-icons/ai";


import { useState,useRef } from 'react';
import NavbarCheck from "./Chek";
import { useDispatch } from "react-redux";
import { getProducts } from "../Redux/ProductReducer/productAction";



function Navbar() {
    
    const navigate = useNavigate()
    const [search, setSearch] = useState("")
    const ref=useRef()
    const dispatch=useDispatch()


    const links = [
        { path: "/", text: "Home" },
        { path: "/topRated", text: "Top-Rated" },
        { path: "/clothing", text: "Clothing" },
        { path: "/dresses", text: "Dresses" },
        { path: "/wedding", text: "Wedding" },
        { path: "/shoes", text: "Shoes" },
        { path: "/Accessories", text: "Accessories" },
        { path: "/gifts", text: "Gifts & Candless" },
        { path: "beauty", text: "Beauty & Wellness" },
        { path: "furniture", text: "Home Furniture" },
    ]

    let paramObj={
        params:{
            q:search
        }
    }

    console.log(paramObj)

    const handleSearch=()=>{
        if(ref.current){
            clearTimeout(ref.current)
        }
        ref.current=setTimeout(()=>{
            dispatch(getProducts("http://localhost:8080/dresses",paramObj))
        },3000)
    }

   
    return (

        <Box >
            <Box w="100%" bg="blue.100" h={9} >
                
            </Box>
            <Box className="navMid" display={"none"}>
            <NavbarCheck/>
            </Box>
            {/* sliding  */}

            <Box pos="relative" mb={"20px"}>
                <Flex mt={9} alignItems={"center"} >
                    <Box>
                        <Link>
                            <Image position={"absolute"} left={"40px"} marginBottom={9}
                                src="https://images.ctfassets.net/5de70he6op10/53ZOE4rRqrxcvv0hg2eSLV/a849085e5f600c618132be2475017746/anthro-logo.svg" /></Link>
                        <Spacer />
                    </Box>

                    <Box pos="absolute" left={"60%"}>
                        <InputGroup w={"250px"} marginRight={"100px"} >
                            <InputLeftElement pointerEvents="none">
                                <SearchIcon color="gray.300" />
                            </InputLeftElement>
                            <Input type="text" value={search} placeholder="Search..." onChange={(e)=>setSearch(e.target.value)} />
                            <Button bg={"blue.200"} _hover={{ bg: "blue" }}> <SearchIcon color="gray.300" onClick={handleSearch}/></Button>
                        </InputGroup>
                    </Box>

                    <Box position="absolute" right={"10rem"} bg={"none"} color={"teal"} >
                        <Flex >
                        
                        <Link onClick={() => navigate("/signin")}><Icon mt="5px" width="50px" height="30px">< AiOutlineUser /></Icon>Login</Link>
                        </Flex>
                    </Box>

                    <Box position="absolute" right={"4rem"}>
                       
                            <Link to="/cart" color={"teal"} onClick={() => navigate("/cart")}><Icon mt="5px" width="50px" height="30px">< BiCartAlt /></Icon>Cart</Link>
                           
                       

                    </Box>

                </Flex>

            </Box>

            <hr w={"100%"}></hr>

            <Box w={"80%"} padding={5} >
                <Flex alignItems={"center"} justifyContent={"space-evenly"}>
                    {links.map((ele) => (
                        <NavLink key={ele.path}
                            to={ele.path}
                            
                        >
                            {ele.text}
                        </NavLink>
                    ))}
                </Flex>
                <Spacer />
                <Box bg='blue.50'></Box>
            </Box>
            <hr w={"100%"} ></hr>
        </Box>
    )
}

export default Navbar


